const ALL = "*";
const READ = "read";
const EXPORT = "export";
const LIST = "list";
const CREATE = "create";
const EDIT = "edit";

const Roles = {
    admin: [{ action: ALL, resource: ALL }],
    projectManager: [{ action: ALL, resource: ALL }],
    teamManager: [
        { action: [READ, LIST, EDIT, EXPORT], resource: "team" },
        { action: [READ, LIST, CREATE, EDIT, EXPORT], resource: "user" },
        { action: [READ, LIST, EDIT, EXPORT], resource: "task" },
    ],
    productor: [
        { action: [READ, LIST, EDIT, EXPORT], resource: "task" }
    ]
};

export default Roles;